import React, {useState, useEffect} from "react";
import assets from "../assets/imgs";
import MainTable from "../components/MainTable";
import CommuteBox from "../components/CommuteBox";
import {useUser} from "../context/UserContext";
import config from "../config/config";
const API_URL = config.API_URL;

function ManagerCommuteMonitoring() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [totalUser, setTotalUser] = useState(1);
  const [todayCommute, setTodayCommute] = useState(0);
  const [todayUnCommute, setTodayUnCommute] = useState(0);
  const [monthCommute, setMonthCommute] = useState(0);
  const {authority, company} = useUser();

  const startupManager = (authority <= 4);
  

  let headTitles = [
    { key: 'id', label: '순번' , searchable:false},
    { key: 'company', label: '기업명' },
    { key: 'owner', label: '대표자'},
    { key: 'week_commute', label: '금주 출근 현황' },
    { key: 'month_commute', label: '금월 출근 현황'},
    { key: 'commute_alarm', label: '출근일수 알림'},
  ];
  if (startupManager) {
    headTitles = headTitles
    .filter(item => item.key !== 'owner' && item.key !== 'company')
    .concat([
      { key: 'account', label: '계정' },
      { key: 'name', label: '성함' },
    ]);
  
    // 순서 지정
    const order = ['id', 'name', 'account', 'week_commute', 'month_commute', 'commute_alarm'];
    headTitles = order.map(key => headTitles.find(item => item.key === key)).filter(Boolean);
  }

  // API 호출 함수
  const fetchData = async () => {
    try {
      // const apiUrl ? 'getCommuteReport' : 'getIncubatorCommuteReport';
      const response = await fetch(`${API_URL}/api/commute/getCommuteReport`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value.commute_list.map((val, index) => ({
          id: index + 1,
          _id: startupManager ? val.user_id : val.startup_id ,
          // _id: val.user_id || index + 1, // ID 설정
          company: val.name || "알 수 없음", // startup_name 매핑
          name : val.name || "알 수 없음",
          account : val.account || "알 수 없음",
          owner: val.owner || '알 수 없음',
          week_commute: val.week || 0,
          month_commute: val.month || 0,
          commute_alarm : val.role || true,
        }));
        setTotalUser(result.value.total_users);
        setTodayCommute(result.value.today_commutes);
        setTodayUnCommute(result.value.today_un_commutes);
        setMonthCommute(result.value.month_commutes);
        setData(formattedData);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const testData = [
    { id: 1, company: "회사 A", owner: "김철수", week_commute: 60, month_commute: 75, commute_alarm: true },
    { id: 2, company: "회사 B", owner: "이영희", week_commute: 80, month_commute: 90, commute_alarm: false },
    { id: 3, company: "회사 C", owner: "박민준", week_commute: 40, month_commute: 55, commute_alarm: true },
  ];

  console.log('today commute is ', `${todayCommute / totalUser * 100}%`);

  return(
    <div style={{flex: 1, display: 'flex', flexDirection: "column"}}>
    {loading ? (
      <p>Loading...</p>
    ) : (
      <div style={styles.container}>
        <div style={styles.rowBox}>
          <CommuteBox 
            text="금일 전체 출근 현황"
            icon= {assets.icons.red_pin}
            // detail = {`${Math.round(todayCommute / totalUser * 100)}%`}
            detail = {`${todayCommute} / ${totalUser}`}
          />
          <CommuteBox
            text="금일 전체 퇴근 현황"
            icon= {assets.icons.red_bus}
            // detail = {`${Math.round(todayUnCommute / totalUser * 100)}%`}
            detail = {`${todayUnCommute} / ${totalUser}`}
          />
          <CommuteBox
            text="이번 달 출퇴근 현황"
            icon= {assets.icons.red_bus}
            // detail = {`${Math.round(monthCommute / totalUser * 100)}%`}
            detail = {`${monthCommute} / ${totalUser}`}
            showInfo = {true}
            infoDescription= {startupManager ? "관내 월 12회 이상 출근 기업 수 입니다.": "관내 월 12회 이상 출근자 수 입니다."}
          />
        </div>
        <MainTable style={{margin: "0px", }} tableHeadTitles={headTitles} tableData={data} pageType={'commute'} mainSearchKey="company"/>      
      </div>  
    )}
  </div>
  );
}

const styles ={
  container:{
    padding: "16px",
    display:"flex",
    flexDirection: "column",
    flex : 1,
  },
  rowBox:{
    display:"flex",
    gap: "20px",
    marginBottom: "20px",
    height:"107px",
  },
}

export default ManagerCommuteMonitoring;